"use strict";
exports.__esModule = true;
exports.defaultTheme = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
var sizes = {
    xl: 1200,
    l: 992,
    m: 768,
    s: 480,
    xs: 320
};
var media = {
    s: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "], ["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), sizes.s, styled_components_1.css.apply(void 0, args));
    },
    m: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "], ["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), sizes.m, styled_components_1.css.apply(void 0, args));
    },
    l: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "], ["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), sizes.l, styled_components_1.css.apply(void 0, args));
    },
    xl: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "], ["\n    @media (min-width: ", "px) {\n      ", ";\n    }\n  "])), sizes.xl, styled_components_1.css.apply(void 0, args));
    }
};
var color = {
    primary: '#2daae1'
};
exports.defaultTheme = {
    openButton: {
        color: '#fff',
        backgroundColor: 'rgba(45,170,225,0.9)'
    },
    color: color,
    button: {
        color: '#fff',
        backgroundColor: color.primary
    },
    media: media
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
